import { FC } from 'react';
import { Form, Payment } from '@repo-level/core-front';
import styled, { css } from 'styled-components/macro';

import { OfUnion } from 'types/common';
import Secure3D from '../../../../assets/images/deposits/3d-secure-logo.webp';
import { CRYPTO_IDENTIFIER, SECURE_3D_IDENTIFIER } from '../helpers';

interface IScFieldBannerProps {
  cardMethod: boolean;
  isCrypto: boolean;
  isDeposit: boolean;
}

const ScFieldBanner = styled.div<IScFieldBannerProps>`
  span {
    display: flex;
    margin-top: ${({ cardMethod, isDeposit }) =>
      !isDeposit ? '24px' : cardMethod ? '0px' : '8px'};

    margin-bottom: ${({ cardMethod, isDeposit }) =>
      !isDeposit ? '16px' : cardMethod ? '8px' : '0px'};
    font-size: ${({ isDeposit }) => (isDeposit ? '12px' : '14px')};
  }

  p {
    display: flex;
    margin-top: 0px;
  }
  .payments-js-lib {
    &__wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: left;
      margin-bottom: 8px;
      gap: 8px;
    }
    &__img-wrapper {
      img {
        width: 24px;
        height: 28px;
      }
    }

    &__description {
      font-size: ${({ cardMethod }) => (cardMethod ? '10px' : '12px')};
      ${({ cardMethod }) =>
        cardMethod &&
        css`
          color: ${({ theme }) => theme.grayColor1};
        `}
      ${({ isCrypto }) =>
        isCrypto &&
        css`
          margin-top: 0px;
        `}
    }
  }

  &:not(:first-child) {
    margin-top: 8px;
  }
`;

export const FieldBanner: FC<
  OfUnion<Form.MethodField>[Form.MethodFieldType.Banner] & {
    paymentAction: Payment.Action;
  }
> = ({ htmlContent, identifier, paymentAction }) => {
  const isDeposit = paymentAction === Payment.Action.Deposit;
  const is3dSecureId = identifier.includes(SECURE_3D_IDENTIFIER);
  const isCrypto = identifier.includes(CRYPTO_IDENTIFIER);

  const getUpdatedHtml = () => {
    if (!is3dSecureId) return htmlContent;

    const newSrc = Secure3D;

    return htmlContent.replace(
      /(<img[^>]*\s+src=["'])[^"']+(["'][^>]*>)/i,
      `$1${newSrc}$2`
    );
  };

  return (
    <ScFieldBanner
      cardMethod={is3dSecureId && isDeposit}
      isCrypto={isCrypto && isDeposit}
      isDeposit={isDeposit}
      dangerouslySetInnerHTML={{
        __html: getUpdatedHtml(),
      }}
    />
  );
};
